/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
import { IconArrowDown } from './Icons';

/* ===========================
CLASS
=========================== */
class ButtonDropdownLimits extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      id: (this.props.id || `dropdown-${Math.random().toString(36).slice(2)}`),
      loading: this.props.loading || false,
      label: (this.props.label || 'Limit 50'),
      style: (this.props.optinonsStyle || 'btn-secondary'),
      options: (this.props.options || {}),
      classes: (this.props.classes || ''),
      open: false,
      prevProps: {},
    };

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * @param {object} nextProps
   * @param state
   */
  static getDerivedStateFromProps(nextProps, state) {
    const { prevProps } = state;

    if (prevProps.id !== nextProps.id) return;

    if (nextProps.options && Object.keys(nextProps.options).length > 0) {
      // eslint-disable-next-line consistent-return
      return {
        label: `Limit ${(Object.keys(nextProps.options).filter((item) => (nextProps.options[item]))[0])}`,
        loading: nextProps.loading || false,
        options: (nextProps.options || {}),
        prevProps: nextProps,
      };
    }

    // eslint-disable-next-line consistent-return
    return prevProps;
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleClick(event) {
    if (this.state.options && Object.keys(this.state.options).length > 0) {
      this.setState((prevState) => ({
        open: !prevState.open,
      }));
    }

    event.preventDefault();
  }

  /**
   * @param {Event} event
   * @param {string} key
   */
  onClick(event, key) {
    const items = this.state.options;
    Object.keys(items).map((item) => {
      items[item] = (item === key);
      return item;
    });

    this.setState({
      open: false,
    }, () => {
      this.props.onUpdateSelection(items);
    });

    event.preventDefault();
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div className={`dropdown${((this.state.open) ? ' show' : '')} ${this.state.classes}`}>
        {/* BUTTON */}
        <button
          className={`btn ${this.state.style}`}
          disabled={this.state.loading}
          type="button"
          id={this.state.id}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={this.handleClick}
        >
          <span>{this.state.label}</span>
          <IconArrowDown />
        </button>
        {/* end BUTTON */}

        {/* DROPDOWN */}
        <div className={`dropdown-menu${((this.state.open && !this.state.loading) ? ' show' : '')}`} aria-labelledby={this.state.id}>
          <div className="dropdown-menu-inner">
            {(this.state.options && Object.keys(this.state.options).length > 0)
              ? (Object.keys(this.state.options).map((key) => (
                <a key={key} onClick={(e) => this.onClick(e, key)} className="dropdown-item" href={`#${key}`}>{key}</a>)))
              : null}
          </div>
        </div>
        {/* end DROPDOWN */}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ButtonDropdownLimits.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  label: PropTypes.string,
  optinonsStyle: PropTypes.string,
  options: PropTypes.object,
  classes: PropTypes.string,
  onUpdateSelection: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ButtonDropdownLimits;
